import { useNavigate } from "react-router-dom";
import addIcon from "../../assests/page/add-icon.svg";
import rightIcon from "../../assests/page/chevron-right-icon.svg";
import { useTranslation } from "react-i18next";

const PageSeperator = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div
      onClick={() => {
        if (props.separatorUrl) {
          navigate(props.separatorUrl);
        } else if (props.separatorContent && !props.separatorloading) {
          props.setPopupContentPosition("flex-end");
          props.setPopupContent(props.separatorContent);
          props.setShowPopup(true);
        }
      }}
      style={props.separatorWidth ? { width: props.separatorWidth } : {}}
      className="gp-separator"
    >
      {props.separatorloading && (
        <div className="gp-separator-text-container">
          <p className="gp-separator-text">{t("common.loading")}...</p>
        </div>
      )}
      {!props.separatorloading && (
        <>
          <div className="gp-separator-text-container">
            <img className="gp-separator-icon" alt="Add Icon" src={addIcon} />
            <p className="gp-separator-text">{props.separatorText}</p>
          </div>
          <img
            className="gp-dropdown-icon"
            alt="Dropdown Icon"
            src={rightIcon}
          />
        </>
      )}
    </div>
  );
};

export default PageSeperator;
